// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"36":"2c53faed","261":"63156f80","265":"46fea574","725":"4a533594"}[chunkId] + ".js";
};